// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610060704/js/" + chunkId + "." + {"44":"d3fffd52","225":"7abe5e50","481":"e4473a1c","486":"da48f3d5","770":"5fdd3a0e"}[chunkId] + ".0.029734606737813474.chunk.js";
};